import { render } from "./ExplanationPane.vue?vue&type=template&id=f5684daa"
import script from "./ExplanationPane.vue?vue&type=script&lang=js"
export * from "./ExplanationPane.vue?vue&type=script&lang=js"

import "./ExplanationPane.vue?vue&type=style&index=0&id=f5684daa&lang=scss"
script.render = render

export default script